import '../App.css';
import { DynamicHeader } from '../components/Header';
import construction from '../images/backgrounds/construction_pic.png';

export default function AmazonWorker() {

    return (
        <div>
            <DynamicHeader visible={true}/>
            <div className='construction-page'>
                <div className='construction-pic-container'>
                <img className='construction-pic' src={construction} alt='pic of a construction crane?'/>
                </div>
                <div>
                    Under Construction...<br/>
                    Please come back later to see my AmazonWorker project
                </div>
            </div>                
        </div>
    )
}